import {Component, Input, OnInit} from '@angular/core';
import {AlarmBase, AlarmComment} from '../../../interfaces/system-status';
import {Observable} from 'rxjs';
import { TableComponent } from '../../../../../../shared/src/lib/components/table/table.component';
import { TableHeaderComponent } from '../../../../../../shared/src/lib/components/table-header/table-header.component';

import { TableRowComponent } from '../../../../../../shared/src/lib/components/table-row/table-row.component';
import { TableCellComponent } from '../../../../../../shared/src/lib/components/table-cell/table-cell.component';
import { TranslateModule } from '@ngx-translate/core';
import { TimeWithAgoPipe } from '../../../../../../shared/src/lib/pipes/time-with-ago.pipe';

@Component({
    selector: 'app-alarm-comments-table',
    templateUrl: './alarm-comments-table.component.html',
    styleUrls: ['./alarm-comments-table.component.scss'],
    imports: [TableComponent, TableHeaderComponent, TableRowComponent, TableCellComponent, TranslateModule, TimeWithAgoPipe]
})
export class AlarmCommentsTableComponent {

  @Input()
  comments: AlarmComment[];
}
